export class ClientConfig {
  public DateFormat: string = "";
  public DateTimeFormat: string = "";
  public AzureAdAuthority: string = "";
  public AzureAdClientId: string = "";
  public AzureAdInstance: string = "";
  public AzureAdTenant: string = "";
  public BrandingURLBES: string = "";
  public BrandingURLVulcan: string = "";
  public FLSItemsPreparationVisible: boolean = false;
  public CustomerAppointmentRescheduling: boolean = false;
  public ShowArrivalWindow: boolean = false;
  public ThoroughItemWarning: string = "";
  public AGradePressureItemWarning: string = "";
  public ServiceEngineerWarning: string = "";
  public SupplementaryTestWarning: string = "";
  public HideConfirmButtonForAGradeCalls: boolean = true;
}